<template>
  <div>
    <div class="npc-dialogue-check el-input-group el-input-group--append el-input-group--prepend">
      <div class="el-input-group__prepend">{{ prepend || "Was" }}</div>
      <el-select
        v-close-on-zoom
        :value="state.selectedNpcKey"
        placeholder="Select NPC"
        :disabled="readonly"
        class="npc-select"
        @input="updateNpc"
      >
        <el-option
          v-for="npc in activeNpcs(emitter.caseConf)"
          :key="npc.key"
          :label="npcLabel(npc)"
          :value="npc.key"
        />
      </el-select>
      <dialogue-check
        check-type="NPC_DIALOGUE"
        :prefix="prefix"
        :placeholder="placeholder"
        :get-dialogue-items="getSelectedNpcItems"
        :put-data="putDataWithNpcData"
        v-bind="$props"
      />
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';
import DialogueCheck from './DialogueCheck.vue';
import { npcLabel } from '~lib/common/utils/labels';
import { activeNpcs } from '~lib/common/utils/npc';


export default {
  name: 'npc-dialogue-check',
  components: {
    DialogueCheck,
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData', 
    'control',
    'checkType',
    'placeholder',
    'prefix',
    'prepend',
    'verb',
    'getDialogueItems',
    'getDialogueItemContent',
  ],
  data() {
    return {
      state: {
        selectedNpcKey: null,
      },
    };
  },
  computed: {
    selectedNpc() {
      const npcs = this.emitter.caseConf.npcs || [];
      return npcs.find(npc => npc.key === this.state.selectedNpcKey);
    }
  },
  created() {
    const data = this.getData(this.ikey);
    this.state.selectedNpcKey = get(data, 'npcKey');
  },
  mounted() {
    this.emitter.trigger('process', this.control);
  },
  methods: {
    updateNpc(key) {
      this.state.selectedNpcKey = key;
      // First time selecting an npc we don't want to emit null id and cause validation errors
      if (!this.getData(this.ikey)) {
        return;
      }
      this.putDataWithNpcData(this.ikey, {});
    },
    putDataWithNpcData(key, data) {
      this.putData(key, {
        ...data,
        type: this.checkType,
        npcKey: this.state.selectedNpcKey,
      });
      this.emitter.trigger('process', this.control);
    },
    getSelectedNpcItems() {
      if (!this.selectedNpc) {
        return [];
      }
      const dialogue = this.selectedNpc.dialogue || {};
      if (this.checkType === 'NPC_COMMAND_COUNT') {
        return dialogue.commands;
      }
      if (this.checkType === 'NPC_UNSOLICITED_DIALOGUE') {
        return dialogue.unsolicited;
      }
      return dialogue.questions;
    },
    npcLabel,
    activeNpcs,
  },
};
</script>

<style scoped>
.npc-select, .dialogue-check {
  display: table-cell;
}
</style>